export const environment = {
  cognito: {
    userPoolId: 'eu-west-1_AfwBfGPOv',
    clientId: '6mcnb8galee060h3je9e9g6g23',
    region: 'eu-west-1',
    domain: 'suppliermanagementapi-dev.auth.eu-west-1.amazoncognito.com',
  },
  apiUrl: 'https://supplier-mgmt-api-app-dev-eun.politeisland-342cb05c.northeurope.azurecontainerapps.io',
  publicResourcesUrl: 'https://stslmdeveun.blob.core.windows.net/public/',
  applicationInsights: {
    enabled: true,
    cloudRoleName: 'Supplier Management WebApp',
  },
};
